/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { CommerceProperty, IContext } from '@msdyn365-commerce/retail-proxy';
import { getDocumentBlobSecureUrlAsync } from '../customProxy/retailExtension/DataActionExtension.g';

/**
 * GetAzureblobstorageSecureurl Input Action
 */
export class GetAzureblobstorageSecureurlInput implements Msdyn365.IActionInput {
    constructor(context: IContext, orderId: string, documentName: string, uniqueId: string) {
        this.orderId = orderId;
        this.documentName = documentName;
        this.context = context;
        this.uniqueId = uniqueId;
    }
    public uniqueId: string;
    public orderId: string;
    public documentName?: string;
    public context: IContext;
    public getCacheKey = () => `BLOBSECUREURL`;
    public getCacheObjectType = () => 'BLOBSECUREURL';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetAzureblobstorageSecureurlData {
    Status: boolean;
    SecureBlobUrl: string;
    ExtensionProperties?: CommerceProperty[] | undefined;
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetAzureblobstorageSecureurlInput, ctx: Msdyn365.IActionContext): Promise<IGetAzureblobstorageSecureurlData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    const response = await getDocumentBlobSecureUrlAsync(input.context, input.orderId, input.documentName || '', input.uniqueId);
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAzureblobstorageSecureurlData>>action,
    id: 'GetAzureblobstorageSecureurl'
});
